'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.buildDateRange = buildDateRange;

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Calendars = require('./Calendars');

var _Calendars2 = _interopRequireDefault(_Calendars);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Builds a selectedDateRange based on the current date range and the date clicked
 * @param    {Object}    currentDateRange      The current date range.
 * @property {Date|null} currentDateRange.from The from date currently selected
 * @property {Date|null} currentDateRange.to   The to date currently selected
 * @param    {Date|null} newDate               The newDate to set in the range.
 * @param    {Date}      dateClicked           The date that was actually clicked.
 * @return   {Object}    The new date range. Keys ['from', 'to'].
 */
function buildDateRange(currentDateRange, newDate, dateClicked) {
  // Creates an array with the dates. Useful for sorting.
  var currentDatesArr = (0, _lodash.compact)([currentDateRange.from, currentDateRange.to]);

  // Based on the present values, create a new array of dates.
  var newDatesArr = function () {
    if (!newDate) {
      // newDate will be null if the dateClicked is already selected.
      return (0, _lodash.compact)(currentDatesArr.map(function (date) {
        if (!(0, _utils.isSameDate)(date, dateClicked)) {
          return date;
        }
        return undefined;
      }));
    }

    if ((0, _lodash.isEmpty)(currentDatesArr)) {
      // no dates have yet been selected
      return [newDate];
    }

    if ((0, _utils.isBeforeDate)(currentDatesArr[0], newDate)) {
      // newDate should replace the `from` date.
      return [newDate, currentDatesArr[0]];
    }

    if ((0, _utils.isAfterDate)(currentDatesArr[0], newDate)) {
      // newDate should replace the `to` date.
      return [currentDatesArr[0], newDate];
    }

    // Failsafe
    return [];
  }();

  // Create the object based on the sorted dates in the array.
  return (0, _lodash.zipObject)(['from', 'to'], newDatesArr);
}

var DateRangeSelector = function (_Component) {
  _inherits(DateRangeSelector, _Component);

  function DateRangeSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateRangeSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateRangeSelector.__proto__ || Object.getPrototypeOf(DateRangeSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedDateRange: _this.props.selectedDateRange || {}
    }, _this.handleSelectDate = function (selectedDate, dateClicked) {
      var selectedDateRange = buildDateRange(_this.props.selectedDateRange || _this.state.selectedDateRange, selectedDate, dateClicked);

      _this.setState({ selectedDateRange: selectedDateRange });
      _this.props.onSelectDate(selectedDateRange);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Handle clicking a date in the calendar grid. Calls `this.props.onSelectDate` with the current
   * selected date range.
   * @param  {Date|null} selectedDate The new date to add to the range
   * @param  {Date} dateClicked The actual date that was clicked.
   */


  _createClass(DateRangeSelector, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Calendars2.default, {
        disabledDates: this.props.disabledDates,
        multiMonth: this.props.multiMonth,
        multiMonthDirection: this.props.multiMonthDirection,
        onSelectDate: this.handleSelectDate,
        range: true,
        selectedDateRange: this.props.selectedDateRange || this.state.selectedDateRange,
        initialVisibleDate: this.props.initialVisibleDate
      });
    }
  }]);

  return DateRangeSelector;
}(_react.Component);

DateRangeSelector.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  multiMonth: _propTypes2.default.bool,
  multiMonthDirection: _propTypes2.default.oneOf(['past', 'future']),
  onSelectDate: _propTypes2.default.func.isRequired,
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  initialVisibleDate: _propTypes2.default.instanceOf(Date)
};
DateRangeSelector.defaultProps = {
  disabledDates: {},
  multiMonth: false,
  multiMonthDirection: 'future',
  selectedDateRange: null,
  initialVisibleDate: null
};
exports.default = DateRangeSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/DateSelectors/DateRangeSelector.js
// module id = 1632
// module chunks = 2